import React from 'react';

const ineligibilityFactors = [
  'Incomplete applications',
  'Lack of clear purpose for funds',
  'Prior grant misuse',
  'Missing documentation'
];

const eligibilityCriteria = [
  'Demonstrated commitment to Islamic studies',
  'Clear educational goals',
  'Proof of intended use of funds (required before and after)',
  'Agreement to provide documentation of fund usage'
];

const EligibilitySection = () => (
  <section className="eligibility-section">
    <h2 className="eligibility-title">Eligibility Requirements</h2>
    <p className="eligibility-desc">
      To ensure our grants benefit those who are committed to Islamic education, we have established the following criteria:
    </p>
    <div className="eligibility-grid">
      <div className="eligibility-card">
        <h3 className="eligibility-card-title">Ineligibility Factors</h3>
        <ul className="eligibility-list">
          {ineligibilityFactors.map((item, idx) => (
            <li key={idx} className="eligibility-list-item ineligible">
              <span className="eligibility-icon ineligible">✖</span> {item}
            </li>
          ))}
        </ul>
      </div>
      <div className="eligibility-card">
        <h3 className="eligibility-card-title">Eligibility Criteria</h3>
        <ul className="eligibility-list">
          {eligibilityCriteria.map((item, idx) => (
            <li key={idx} className="eligibility-list-item eligible">
              <span className="eligibility-icon eligible">✔</span> {item}
            </li>
          ))}
        </ul>
      </div>
    </div>
  </section>
);

export default EligibilitySection;
